<template>
  <main dir="rtl" class="login-page-wrapper">
    <!-- اشکال پس‌زمینه -->
    <div class="bg-shapes">
      <div class="shape shape-1"></div>
      <div class="shape shape-2"></div>
      <div class="shape shape-3"></div>
    </div>
    
    <div class="container login-container">
      <div class="row justify-content-center align-items-center h-100">
        <!-- عرض کلی باکس کنترل شده -->
        <div class="col-lg-8 col-md-11 col-sm-12">
          <div class="login-card glass-effect">
            <div class="row g-0 h-100">
              
              <!-- بخش فرم (راست) -->
              <div class="col-lg-6 col-md-12 form-section">
                <div class="form-content" style="height:33vw">
                  <!-- لوگوی SVG جدید -->
                  <div class="brand-logo mb-2">
                    <svg class="custom-logo-svg" viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <defs>
                        <linearGradient id="grad1" x1="0%" y1="0%" x2="100%" y2="100%">
                          <stop offset="0%" style="stop-color:#0c397b;stop-opacity:1" />
                          <stop offset="100%" style="stop-color:#2b7de0;stop-opacity:1" />
                        </linearGradient>
                      </defs>
                      <circle cx="50" cy="50" r="45" stroke="url(#grad1)" stroke-width="4" fill="white"/>
                      <path d="M30 50 L45 65 L70 35" stroke="url(#grad1)" stroke-width="6" stroke-linecap="round" stroke-linejoin="round"/>
                      <circle cx="50" cy="50" r="15" stroke="#fdb916" stroke-width="3" fill="none" opacity="0.8"/>
                    </svg>
                  </div>
                  
                  <h2  class="form-title">ورود به سامانه</h2>
                  
                  <form @submit.prevent="handleClick" class="mt-4" novalidate>
                    <!-- نام کاربری -->
                    <div class="custom-input-group" :class="{'has-error': errors.username}">
                      <div class="input-wrapper">
                        <input 
                          dir="rtl" 
                          v-model="username" 
                          type="text" 
                          id="username"
                          class="custom-input" 
                          :class="{'filled': username}"
                          @input="clearError('username')"
                        />
                        <label for="username" class="floating-label">نام کاربری</label>
                        <span class="input-icon user-icon">
                          <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path><circle cx="12" cy="7" r="4"></circle></svg>
                        </span>
                      </div>
                      <span class="error-message" v-if="errors.username">{{ errors.username }}</span>
                    </div>
                    <!-- رمز عبور -->
                   <div class="custom-input-group" :class="{'has-error': errors.password}">
                      <div class="input-wrapper">
                        <input 
                          ref="passwordInput"
                          dir="rtl" 
                          v-model="password" 
                          :type="passwordShow ? 'text' : 'password'" 
                          id="password"
                          class="custom-input" 
                          :class="{'filled': password}"
                          @input="clearError('password')"
                        />
                        <label for="password" class="floating-label">رمز عبور</label>
                        <span class="input-icon lock-icon">
                           <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="11" width="18" height="11" rx="2" ry="2"></rect><path d="M7 11V7a5 5 0 0 1 10 0v4"></path></svg>
                        </span>
                        
                        <!-- دکمه نمایش رمز -->
                        <button type="button" @mousedown.prevent="togglePassword" class="toggle-password-btn">
                          <svg v-if="!passwordShow" xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" viewBox="0 0 24 24" fill="none" stroke="#666" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                            <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"></path>
                            <circle cx="12" cy="12" r="3"></circle>
                          </svg>
                          <svg v-else xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" viewBox="0 0 24 24" fill="none" stroke="#666" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                            <path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24"></path>
                            <line x1="1" y1="1" x2="23" y2="23"></line>
                          </svg>
                        </button>
                      </div>
                      <span class="error-message" v-if="errors.password">{{ errors.password }}</span>
                    </div>
                    <!-- کد امنیتی -->
                    <div class="custom-input-group captcha-group" :class="{'has-error': errors.captcha}">
                      <div class="row g-2 align-items-center">
                        <div class="col-7">
                          <div class="input-wrapper">
                            <input 
                              dir="rtl" 
                              v-model="inputCode" 
                              maxlength="6" 
                              type="text" 
                              id="captcha"
                              class="custom-input" 
                              :class="{'filled': inputCode}"
                              @input="clearError('captcha')"
                            />
                            <label for="captcha" class="floating-label">کد امنیتی</label>
                          </div>
                        </div>
                        <div class="col-5">
                          <div class="captcha-box" @click="generateCode" title="برای تغییر کد کلیک کنید">
                            <!-- تغییرات: استفاده از کانتینر captcha-content برای ثابت ماندن لودینگ -->
                            <div class="captcha-content">
                              <img 
                                v-if="captcha_image" 
                                :src="captcha_image" 
                                alt="Captcha" 
                                class="captcha-img"
                                @load="captchaLoaded"
                              >
                              <div v-if="isCaptchaLoading" class="captcha-spinner"></div>
                            </div>
                            
                            <div class="captcha-overlay">
                              <span class="refresh-icon">↻</span>
                            </div>
                          </div>
                        </div>
                      </div>
                      <span class="error-message" v-if="errors.captcha">{{ errors.captcha }}</span>
                    </div>
                    <!-- دکمه ورود -->
                    <button type="submit" class="btn-submit" :disabled="isLoading">
                      <span style="font-size:0.85vw" v-if="!isLoading" class="btn-text">ورود به سامانه</span>
                      <span v-else class="loading-wrapper">
                        <span class="spinner"></span>
                        <span style="font-size:0.85vw" class="loading-text">در حال پردازش...</span>
                      </span>
                    </button>
                    
                    <div class="text-center mt-3">
                      <a href="#" @click.prevent="handleForgotPassword" class="forgot-pass">رمز عبور خود را فراموش کرده‌اید؟</a>
                      <!-- نمایش خطای عمومی به صورت متن قرمز جذاب -->
                      <div v-if="generalError" class="general-error-box">
                        <span style="font-size: 0.8vw;" class="error-icon">⚠</span>
                        <span style="font-size: 0.7vw;">{{ generalError }}</span>
                      </div>
                    </div>
                    <!-- اطلاعات پشتیبانی و نسخه (داخل باکس فرم) -->
                    
                  </form>
                  
                </div>
                <div class="footer-info mt-4">
                      <div class="info-box">
                        <div class="info-item">
                          <!-- تغییر: آیکن موبایل قرینه شده -->
                          <svg class="info-icon phone-icon-flipped" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"></path></svg>
                          <span class="info-text">۰۲۱-۸۸۵۳۳۵۲۸</span>
                        </div>
                        <div class="divider"></div>
                        <div class="info-item">
                          <!-- تغییر: آیکن نسخه به آیکن اطلاعات تغییر یافت -->
                          <svg class="info-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"></circle><line x1="12" y1="16" x2="12" y2="12"></line><line x1="12" y1="8" x2="12.01" y2="8"></line></svg>
                          <span class="info-text">نسخه فعلی : ۱.۰۹</span>
                        </div>
                      </div>
                    </div>
              </div>
              
              <!-- بخش تصویر و اطلاعات (چپ) -->
              <div class="col-lg-6 col-md-12 image-section d-none d-lg-flex flex-column justify-content-center align-items-center">
                <div class="image-content">
                  <div class="logo-circle">
                    <BehfamLOGOWhite name="" />
                  </div>
                </div>
                <p class="behfam-desc">سامانه جامع و یکپارچه مدیریت سازمانی</p>
                 <!-- لیست ماژول‌ها با استایل جذاب Grid -->
                  <div class="modules-grid">
                    
                    <div class="module-card">
                      <div class="module-icon-box">
                        <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="3" width="7" height="7"></rect><rect x="14" y="3" width="7" height="7"></rect><rect x="14" y="14" width="7" height="7"></rect><rect x="3" y="14" width="7" height="7"></rect></svg>
                      </div>
                      <span>مدیریت ساختار سازمانی</span>
                    </div>
                    <div class="module-card">
                      <div class="module-icon-box">
                        <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path><circle cx="9" cy="7" r="4"></circle><path d="M23 21v-2a4 4 0 0 0-3-3.87"></path><path d="M16 3.13a4 4 0 0 1 0 7.75"></path></svg>
                      </div>
                      <span>مدیریت ذی‌نفعان</span>
                    </div>
                    <div class="module-card">
                      <div class="module-icon-box">
                        <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="2" y="3" width="20" height="14" rx="2" ry="2"></rect><line x1="8" y1="21" x2="16" y2="21"></line><line x1="12" y1="17" x2="12" y2="21"></line></svg>
                      </div>
                      <span>مدیریت فرآیندهای سازمانی</span>
                    </div>
                  
                    <div class="module-card">
                      <div class="module-icon-box">
                        <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="12" y1="1" x2="12" y2="23"></line><path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6"></path></svg>
                      </div>
                      <span>مدیریت مالی و بهره‌وری</span>
                    </div>
                    <div class="module-card">
                      <div class="module-icon-box">
                        <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"></circle><line x1="2" y1="12" x2="22" y2="12"></line><path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z"></path></svg>
                      </div>
                      <span>مدیریت استراتژیک</span>
                    </div>
                    <div class="module-card">
                      <div class="module-icon-box">
                        <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M12 20V10"></path><path d="M18 20V4"></path><path d="M6 20v-4"></path></svg>
                      </div>
                      <span>مدیریت عملکرد</span>
                    </div>
                    <div class="module-card">
                      <div class="module-icon-box">
                        <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"></path><line x1="12" y1="9" x2="12" y2="13"></line><line x1="12" y1="17" x2="12.01" y2="17"></line></svg>
                      </div>
                      <span>مدیریت ریسک</span>
                    </div>
                    <!-- ماژول جدید: مسئله‌شناسی -->
                    <div class="module-card">
                      <div class="module-icon-box">
                        <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"></circle><path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3"></path><line x1="12" y1="17" x2="12.01" y2="17"></line></svg>
                      </div>
                      <span>مسئله‌شناسی</span>
                    </div>
                  </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </main>
</template>
<script>
import CaptchaCode from 'vue-captcha-code';
import router from "@/router";
import cookies from "vue-cookies";
import BehfamLOGOWhite from "@/components/Icons/BehfamLOGOWhite.vue";
export default {
  name: "Login",
  components: {
    BehfamLOGOWhite,
    CaptchaCode,
  },
  data() {
    return {
      username: null,
      password: null,
      code: '',
      inputCode: "",
      passwordShow: false,
      isLoading: false,
      captcha_image: '',
      captcha_key: '',
      isCaptchaLoading: false, // متغیر جدید برای وضعیت لودینگ
      // متغیر جدید برای نمایش خطای عمومی
      generalError: '',
      // آبجکت خطاهای فرم
      errors: {
        username: '',
        password: '',
        captcha: ''
      }
    }
  },
  methods: {
    clearError(field) {
      this.errors[field] = '';
      // پاک کردن خطای عمومی هنگام تایپ در هر فیلدی
      this.generalError = '';
    },
    togglePassword() {
      this.passwordShow = !this.passwordShow;
      this.$nextTick(() => {
        if (this.$refs.passwordInput) {
          this.$refs.passwordInput.focus();
        }
      });
    },
    // متد جدید برای فراموشی رمز عبور
    handleForgotPassword() {
      // نمایش خطا در باکس قرمز زیر لینک
      this.errors.username=null;
      this.errors.password=null;
      this.errors.captcha=null;
      this.generalError = 'شما مجاز به انجام این عملیات نمی باشید';
    },
    async handleClick() {
      if (this.isLoading) return;
      
      // ریست کردن ارورها
      this.errors = { username: '', password: '', captcha: '' };
      this.generalError = ''; // پاک کردن خطای عمومی
      
      // اعتبارسنجی پیشرفته
      let isValid = true;
      if (!this.username || this.username.trim() === '') {
        this.errors.username = 'وارد کردن نام کاربری الزامی است';
        isValid = false;
      }
      if (!this.password || this.password.trim() === '') {
        this.errors.password = 'وارد کردن رمز عبور الزامی است';
        isValid = false;
      }
      // تغییر: بررسی خالی بودن کپچا و نمایش خطا
      if (!this.inputCode || this.inputCode.trim() === '') {
        this.errors.captcha = 'وارد کردن کد امنیتی اجباری است';
        isValid = false;
      } else if (this.inputCode.length !== 6) {
        this.errors.captcha = 'کد امنیتی باید ۶ کاراکتر باشد';
        isValid = false;
      }
      
      if (!isValid) return;
      
      this.isLoading = true;
      try {
        const response = await this.login();
        this.handleLoginResponse(response);
      } catch (error) {
        this.generateCode();
        // نمایش خطای سرور در باکس قرمز
        this.generalError = error.message || 'خطای نامشخص رخ داده است';
      } finally {
        this.isLoading = false;
      }
    },
    async login() {
      const response = await fetch(`${this.base_url}/auth/login`, {
        credentials: 'include',
          headers: {
          
          'Accept': 'application/json',
        },method: 'POST',
         
        headers: {
          'Content-type': 'application/json; charset=UTF-8',
        },
        body: JSON.stringify({
          username: this.username,
          password: this.password,
          captcha_code: this.inputCode,
          captcha_key: this.captcha_key,
        }),
      });
      
      const data = await response.json();
      
      // بررسی وضعیت پاسخ و پرتاب خطا برای نمایش در باکس قرمز
      if (!response.ok) {
        // تغییر: اولویت با خطای ارسالی از سرور (data.error) است
        throw new Error(data.error || 'نام کاربری یا رمز عبور اشتباه است');
      }
      return data;
    },
    handleLoginResponse(response) {
      if (response.error) {
        this.generalError = response.error;
        this.inputCode = '';
        this.generateCode();
      } else if (response.id) {
        this.$store.commit('login', response);
        
       
      }
    },
   
    handleChange(code) {
      this.code = code
    },
    // متد مربوط به لود شدن عکس
    captchaLoaded() {
      this.isCaptchaLoading = false;
    },
        generateCode() {
      // شروع لودینگ
      this.isCaptchaLoading = true; 
      
      const requestOptions = {
        credentials: 'include',
          headers: {
          
          'Accept': 'application/json',
        },method: "GET",
        redirect: "follow"
      };
      
      fetch(`${this.base_url}/captcha`, requestOptions)
          .then((response) => {
             // بررسی می‌کنیم که آیا پاسخ اوکی است یا خیر
             if (!response.ok) {
               throw new Error('Network response was not ok');
             }
             return response.json();
          })
          .then((response) => {
            // فقط اگر داده معتبر بود، عکس را آپدیت می‌کنیم
            if (response.captcha_image) {
              this.captcha_image = response.captcha_image
            }
            if (response.captcha_key) {
              this.captcha_key = response.captcha_key
            }
            // نکته مهم: اینجا isCaptchaLoading را false نمی‌کنیم!
            // صبر می‌کنیم تا رویداد @load در عکس اجرا شود.
          })
          .catch((error) => {
            console.error("Captcha Error:", error);
            // در صورت خطا (قطعی نت یا ارور سرور):
            // ما isCaptchaLoading را false نمی‌کنیم تا اسپینر متوقف نشود.
            // این باعث می‌شود کاربر متوجه شود که هنوز در حال تلاش است یا مشکلی وجود دارد.
            
            // اگر می‌خواهید بعد از چند ثانیه تلاش دوباره کند، می‌توانید از setTimeout استفاده کنید:
            // setTimeout(() => this.generateCode(), 3000); 
          });
    },
  },
  mounted() {
    this.generateCode();
  }
}
</script>
<style scoped lang="scss">
// تنظیمات پایه
.login-page-wrapper {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);
  position: relative;
  overflow: hidden;
  font-family: 'dana', sans-serif;
}
// اشکال پس‌زمینه
.bg-shapes {
  position: absolute;
  width: 100%;
  height: 100%;
  z-index: 0;
  overflow: hidden;
  
  .shape {
    position: absolute;
    border-radius: 50%;
    filter: blur(60px);
    opacity: 0.5;
    animation: float 8s infinite ease-in-out;
  }
  
  .shape-1 {
    width: 35vw;
    height: 35vw;
    background: linear-gradient(45deg, rgba(12, 57, 123, 0.4), rgba(43, 125, 224, 0.2));
    top: -10vw;
    right: -5vw;
    animation-delay: 0s;
  }
  
  .shape-2 {
    width: 25vw;
    height: 25vw;
    background: linear-gradient(45deg, rgba(12, 57, 123, 0.3), rgba(253, 185, 22, 0.1));
    bottom: -5vw;
    left: -5vw;
    animation-delay: 2s;
  }
  .shape-3 {
    width: 15vw;
    height: 15vw;
    background: rgba(12, 57, 123, 0.2);
    top: 40%;
    left: 40%;
    animation-delay: 4s;
  }
}
@keyframes float {
  0%, 100% { transform: translate(0, 0); }
  50% { transform: translate(-20px, 20px); }
}
// کارت اصلی لاگین
.login-card {
  background: rgba(255, 255, 255, 0.95);
  backdrop-filter: blur(20px);
  border-radius: 1.5vw;
  box-shadow: 0 1vw 2.5vw rgba(0, 0, 0, 0.08);
  overflow: hidden;
  border: 1px solid rgba(255, 255, 255, 0.6);
  // تنظیم ارتفاع ثابت برای جلوگیری از تغییر سایز
  min-height: 43vw; 
  max-height: 43vw; // ارتفاع ثابت
  height: 43vw; // ارتفاع دقیق
  position: relative;
  z-index: 1;
  display: flex;
  flex-direction: column;
}
// بخش فرم
.form-section {
  padding: 2.5vw 3vw;
  display: flex;
  flex-direction: column;
  justify-content: center;
  // اضافه کردن اسکرول اگر محتوا زیاد شد (در حالت ریسپانسیو یا خطاهای زیاد)
  overflow-y: auto; 
}
.form-title {
  font-size: 1.2vw !important;
  color: #0c397b;
  font-weight: bold;
  margin-bottom: 0.5vw;
}
// استایل لوگوی SVG جدید
.custom-logo-svg {
  width: 4vw;
  height: 4vw;
  display: block;
  margin: 0 auto;
  filter: drop-shadow(0 0.2vw 0.4vw rgba(12, 57, 123, 0.2));
}
// استایل اینپوت‌ها و خطاها
.custom-input-group {
  margin-bottom: 1.6vw;
  position: relative;
  
  &.has-error {
    .custom-input {
      border-color: #ef5350;
      background: #ffebee;
    }
    .floating-label {
      color: #ef5350;
    }
    .input-icon {
      color: #ef5350;
    }
  }
}
.error-message {
  display: block;
  color: #ef5350;
  font-size: 0.8vw;
  margin-top: 0.2vw;
  text-align: right;
  animation: fadeIn 0.3s ease;
}
@keyframes fadeIn {
  from { opacity: 0; transform: translateY(-5px); }
  to { opacity: 1; transform: translateY(0); }
}
.input-wrapper {
  position: relative;
}
.custom-input {
  width: 100%;
  padding: 0.8vw 3.5vw 0.8vw 1.2vw;
  font-size: 0.99vw;
  color: #333;
  background: #f8f9fa;
  border: 0.1vw solid transparent;
  border-radius: 0.8vw;
  transition: all 0.3s ease;
  outline: none;
  font-family: 'dana', sans-serif;
  
  &:focus {
    background: #fff;
    border-color: #0c397b;
    box-shadow: 0 0 0 0.2vw rgba(12, 57, 123, 0.1);
  }
  
  &.filled + .floating-label,
  &:focus + .floating-label {
    top: -0.5vw;
    right: 0.8vw;
    font-size: 0.6vw;
    color: #0c397b;
    background: #f8f9fa;
    padding: 0 0.3vw;
    border-radius: 0.3vw;
  }
}
.floating-label {
  position: absolute;
  right: 2.6vw;
  top: 50%;
  transform: translateY(-50%);
  color: #999;
  font-size: 0.8vw !important;
  pointer-events: none;
  transition: all 0.3s ease;
  background: transparent;
  z-index: 1;
}
.input-icon {
  position: absolute;
  right: 1vw;
  top: 50%;
  transform: translateY(-50%);
  width: 1vw;
  height: 1vw;
  color: #999;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 2;
}
.toggle-password-btn {
  position: absolute;
  left: 1vw;
  top: 50%;
  transform: translateY(-50%);
  background: none;
  border: none;
  cursor: pointer;
  color: #082656;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 2vw;
  height: 2vw;
  z-index: 2;
  
  &:hover {
    color: #0c397b;
  }
}
// کپچا
.captcha-group {
  margin-bottom: 0.8vw;
  .input-wrapper {
    margin-bottom: 0;
  }
}
.captcha-box {
  width: 100%;
  height: 3vw;
  border-radius: 0.8vw;
  overflow: hidden;
  position: relative;
  cursor: pointer;
  border: 0.1vw solid #eee;
  transition: all 0.3s;
  
  &:hover {
    border-color: #0c397b;
    .captcha-overlay {
      opacity: 1;
    }
  }
}

// استایل‌های جدید برای ثابت ماندن لودینگ کپچا
.captcha-content {
  width: 100%;
  height: 100%;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f0f0f0;
}

.captcha-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 1;
}

.captcha-spinner {
  width: 1.5vw;
  height: 1.5vw;
  border: 0.15vw solid rgba(12, 57, 123, 0.1);
  border-radius: 50%;
  border-top-color: #0c397b;
  animation: spin 0.8s linear infinite;
  position: relative; // تغییر از absolute به relative
  z-index: 2;
}

.captcha-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0,0,0,0.3);
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 0;
  transition: opacity 0.3s;
  z-index: 3;
  
  .refresh-icon {
    color: white;
    font-size: 1vw;
    font-weight: bold;
  }
}
// دکمه ارسال
.btn-submit {
  width: 100%;
  padding: 0.9vw;
  background: #0c397b;
  color: white;
  border: none;
  border-radius: 0.8vw;
  font-size: 0.9vw;
  font-weight: bold;
  cursor: pointer;
  transition: all 0.3s;
  box-shadow: 0 0.2vw 0.8vw rgba(12, 57, 123, 0.3);
  margin-top: 1.2vw;
  position: relative;
  overflow: hidden;
  
  &:hover:not(:disabled) {
    transform: translateY(-0.1vw);
    box-shadow: 0 0.3vw 1vw rgba(12, 57, 123, 0.4);
    background: #0a2d63;
  }
  
  &:active:not(:disabled) {
    transform: translateY(0);
  }
  
  &:disabled {
    opacity: 0.8;
    cursor: not-allowed;
  }
}
.btn-text {
  display: block;
  transition: opacity 0.3s;
}
.loading-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.6vw;
  width: 100%;
}
.spinner {
  width: 1.2vw;
  height: 1.2vw;
  border: 0.15vw solid rgba(255,255,255,0.3);
  border-radius: 50%;
  border-top-color: #fff;
  animation: spin 0.8s linear infinite;
}
.loading-text {
  animation: pulse 1.5s infinite ease-in-out;
}
@keyframes spin {
  to { transform: rotate(360deg); }
}
@keyframes pulse {
  0%, 100% { opacity: 1; }
  50% { opacity: 0.6; }
}
.forgot-pass {
  color: #666;
  font-size: 0.8vw;
  text-decoration: none;
  transition: color 0.3s;
  margin-top: 1.5vw;
  display: block;
  margin-bottom: 1.5vw;
  
  &:hover {
    color: #0c397b;
  }
}
// استایل جدید برای باکس خطای عمومی (قرمز جذاب)
.general-error-box {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5vw;
  background: rgba(239, 83, 80, 0.1);
  border: 1px solid rgba(239, 83, 80, 0.3);
  border-radius: 0.8vw;
  padding: 0.6vw 1vw;
  margin-top: 0.5vw;
  color: #d32f2f;
  font-size: 0.85vw;
  font-weight: 500;
  animation: shake 0.4s cubic-bezier(.36,.07,.19,.97) both;
  
  .error-icon {
    font-size: 1.1vw;
    display: inline-block;
  }
}
@keyframes shake {
  10%, 90% { transform: translate3d(-1px, 0, 0); }
  20%, 80% { transform: translate3d(2px, 0, 0); }
  30%, 50%, 70% { transform: translate3d(-4px, 0, 0); }
  40%, 60% { transform: translate3d(4px, 0, 0); }
}
// فوتر اطلاعات (پشتیبانی و نسخه) - داخل باکس
.footer-info {
  margin-top: 0.6vw !important;
  padding-top: 1vw;
  border-top: 0.05vw solid #eee;
  
  .info-box {
    display: flex;
    justify-content: space-between;
    align-items: center;
    background: #1e293b;
    padding: 0.6vw 1.2vw;
    border-radius: 0.8vw;
    box-shadow: 0 0.2vw 0.5vw rgba(0,0,0,0.1);
  }
  
  .info-item {
    display: flex;
    align-items: center;
    gap: 0.6vw;
    
    .info-icon {
      width: 1.1vw;
      height: 1.1vw;
      color: #ffffff;
      display: flex;
      align-items: center;
      justify-content: center;
    }
    
    // تغییر: کلاس جدید برای قرینه کردن آیکن موبایل
    .phone-icon-flipped {
      transform: scaleX(-1);
    }
    
    .info-text {
      font-size: 0.85vw;
      color: #ffffff;
      font-family: 'dana', sans-serif;
      font-weight: 500;
      direction: rtl;
    }
  }
  
  .divider {
    width: 0.05vw;
    height: 1.5vw;
    background: rgba(255,255,255,0.2);
  }
}
// بخش تصویر سمت چپ
.image-section {
  background: linear-gradient(135deg, #0c397b 0%, #082656 100%);
  padding: 2.5vw;
  color: white;
  position: relative;
  overflow: hidden; // جلوگیری از بیرون زدگی محتوا
  
  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-image: url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23ffffff' fill-opacity='0.1'%3E%3Cpath d='M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E");
    opacity: 0.3;
  }
}
.image-content {
  position: relative;
    z-index: 2;
    text-align: center;
    display: flex;
    height: 29%;
    margin-top: 3.5vw;
}
.logo-circle {
  // کوچک کردن لوگوی بهفام
  width: 5vw; 
  height: 5vw; 
  max-width: 5vw; 
  max-height: 5vw; 
  background: rgba(255,255,255,0.2);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 0.6vw; 
  backdrop-filter: blur(5px);
  border: 0.15vw solid rgba(255,255,255,0.3);
}
.behfam-desc {
  font-size: 1.1vw;
    font-family: "dana";
    margin-bottom: 2.3vw;
    opacity: 0.9;
    margin-top: -1vw;
}

// لیست ماژول‌ها - استایل جذاب Grid
.modules-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 0.6vw; 
  width: 100%;
  max-width: 95%; 
  
  .module-card {
    background: rgba(255, 255, 255, 0.1);
    border: 1px solid rgba(255, 255, 255, 0.15);
    border-radius: 0.8vw;
    padding: 0.6vw 0.4vw; 
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    text-align: center;
    transition: all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);
    backdrop-filter: blur(5px);
    cursor: default;
    &:hover {
      background: rgba(255, 255, 255, 0.25);
      transform: translateY(-3px);
      box-shadow: 0 0.5vw 1vw rgba(0, 0, 0, 0.2);
      border-color: rgba(255, 255, 255, 0.4);
    }
    .module-icon-box {
      width: 1.8vw; 
      height: 1.8vw;
      margin-bottom: 0.4vw; 
      color: rgba(255, 255, 255, 0.9);
      display: flex;
      align-items: center;
      justify-content: center;
    }
    span {
      font-size: 0.7vw; 
      font-weight: 500;
      color: #fff;
      line-height: 1.2;
    }
  }
}
// ریسپانسیو
@media (max-width: 991px) {
  .login-card {
    flex-direction: column;
    min-height: auto;
    max-height: none; // در موبایل ارتفاع آزاد
    height: auto;
    border-radius: 1.5rem;
    width: 90%;
    margin: 0 auto;
  }
  
  .image-section {
    display: none;
  }
  
  .form-section {
    padding: 2rem;
    overflow-y: visible; // در موبایل نیازی به اسکرول داخلی نیست
  }
  
  .custom-logo-svg {
    width: 60px;
    height: 60px;
  }
  
  .form-title { font-size: 1.5rem; }
  .form-subtitle { font-size: 0.9rem; }
  .custom-input { padding: 12px 40px 12px 15px; font-size: 0.99vw; border-radius: 10px; }
  .floating-label { font-size: 0.8vw; right: 15px; }
  .input-icon { width: 18px; height: 18px; right: 12px; }
  .toggle-password-btn { width: 18px; height: 18px; left: 12px; }
  .btn-submit { padding: 12px; font-size: 1rem; border-radius: 10px; }
  .captcha-box { height: 40px; border-radius: 10px; }
  .error-message { font-size: 0.75rem; }
  
  .footer-info {
    .info-box {
      flex-direction: column;
      gap: 10px;
      padding: 1rem;
    }
    .divider {
      width: 100%;
      height: 1px;
    }
    .info-text { font-size: 1rem; }
    .info-icon { width: 24px; height: 24px; }
  }
  
  .general-error-box {
    font-size: 0.9rem;
    padding: 10px;
    .error-icon { font-size: 1.2rem; }
  }
}
// --- حل مشکل تداخل لیبل با Autofill مرورگر ---
// ۱. انتخاب اینپوت‌هایی که توسط مرورگر پر شده‌اند (استاندارد)
.custom-input:-webkit-autofill,
.custom-input:-webkit-autofill:hover,
.custom-input:-webkit-autofill:focus,
.custom-input:-webkit-autofill:active {
  // حفظ رنگ پس‌زمینه و متن هنگام Autofill
  -webkit-box-shadow: 0 0 0 30px #f8f9fa inset !important;
  -webkit-text-fill-color: #333 !important;
  transition: background-color 5000s ease-in-out 0s; // جلوگیری از تغییر ناگهانی رنگ
}
// ۲. ترفند اصلی: وقتی اینپوت Autofill شد، لیبل را بالا ببر
// این سلکتور می‌گوید: اگر اینپوت در حالت Autofill است، لیبل کنار آن را پیدا کن
.custom-input:-webkit-autofill + .floating-label {
  top: -0.5vw;
  right: 0.8vw;
  font-size: 0.6vw;
  color: #0c397b;
  background: #f8f9fa;
  padding: 0 0.3vw;
  border-radius: 0.3vw;
}
// ۳. حالت فوکوس روی اینپوت‌های Autofill شده (برای تغییر رنگ پس‌زمینه به سفید)
.custom-input:-webkit-autofill:focus {
  -webkit-box-shadow: 0 0 0 30px #fff inset !important;
  border-color: #0c397b;
}
// وقتی فوکوس شد، لیبل باید هم بالا بماند (با پس‌زمینه سفید)
.custom-input:-webkit-autofill:focus + .floating-label {
  background: #fff;
}
</style>